import { a as __extends, b as __awaiter, c as __rest, d as __assign, C as ClientSDKProxyContext, e as __generator } from './chunk-525a49bc.js';
import React from 'react';
import { withTheme, ThemeProvider } from 'styled-components';
import { E as ERROR_NO_SDK_CLIENT, a as ERROR_API_UNEXPECTED_RESULTS } from './chunk-bc685b06.js';
import { L as LoadingBlock } from './chunk-c2b06a8e.js';
import { C as CanceledPromiseException, c as connectPromiseToUnmountState } from './chunk-6cec2b98.js';
import { S as SDK_LIST_LIMIT } from './chunk-e1ac37a6.js';

var withAsset = function (WrapperComponent) { var _a; return _a = /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1(props) {
            var _this = _super.call(this, props) || this;
            _this.isComponentUnmounted = false;
            _this.state = {
                isLoading: true,
                asset: null,
                assetId: props.assetId,
            };
            return _this;
        }
        class_1.getDerivedStateFromProps = function (props, state) {
            if (props.assetId !== state.assetId) {
                return {
                    isLoading: true,
                    asset: null,
                    assetId: props.assetId,
                };
            }
            return null;
        };
        class_1.prototype.componentDidMount = function () {
            this.client = this.context(WrapperComponent.displayName || '');
            if (!this.client) {
                console.error(ERROR_NO_SDK_CLIENT);
                return;
            }
            this.loadAsset();
        };
        class_1.prototype.componentWillUnmount = function () {
            this.isComponentUnmounted = true;
        };
        class_1.prototype.componentDidUpdate = function (prevProps) {
            if (prevProps.assetId !== this.props.assetId) {
                this.loadAsset();
            }
        };
        class_1.prototype.loadAsset = function () {
            return __awaiter(this, void 0, void 0, function () {
                var assets, error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, connectPromiseToUnmountState(this, this.client.assets.retrieve([{ id: this.props.assetId }]))];
                        case 1:
                            assets = _a.sent();
                            if (!assets || assets.length !== 1) {
                                console.error(ERROR_API_UNEXPECTED_RESULTS);
                                return [2 /*return*/];
                            }
                            this.setState({
                                isLoading: false,
                                asset: assets[0],
                            });
                            if (this.props.onAssetLoaded) {
                                this.props.onAssetLoaded(assets[0]);
                            }
                            return [3 /*break*/, 3];
                        case 2:
                            error_1 = _a.sent();
                            if (error_1 instanceof CanceledPromiseException !== true) {
                                throw error_1;
                            }
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        class_1.prototype.render = function () {
            var _a = this.props, assetId = _a.assetId, customSpinner = _a.customSpinner, onAssetLoaded = _a.onAssetLoaded, restProps = __rest(_a, ["assetId", "customSpinner", "onAssetLoaded"]);
            var _b = this.state, isLoading = _b.isLoading, asset = _b.asset;
            if (isLoading) {
                return customSpinner || React.createElement(LoadingBlock, null);
            }
            if (asset) {
                return (React.createElement(WrapperComponent, __assign({}, restProps, { asset: asset })));
            }
            return null;
        };
        return class_1;
    }(React.Component)),
    _a.contextType = ClientSDKProxyContext,
    _a; };

var withAssetEvents = function (WrapperComponent) { var _a; return _a = /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1(props) {
            var _this = _super.call(this, props) || this;
            _this.isComponentUnmounted = false;
            _this.state = {
                isLoading: true,
                assetEvents: null,
                assetId: props.assetId,
            };
            return _this;
        }
        class_1.getDerivedStateFromProps = function (props, state) {
            if (props.assetId !== state.assetId) {
                return {
                    isLoading: true,
                    assetEvents: null,
                    assetId: props.assetId,
                };
            }
            return null;
        };
        class_1.prototype.componentDidMount = function () {
            this.client = this.context(WrapperComponent.displayName || '');
            if (!this.client) {
                console.error(ERROR_NO_SDK_CLIENT);
                return;
            }
            this.loadAssetEvents();
        };
        class_1.prototype.componentWillUnmount = function () {
            this.isComponentUnmounted = true;
        };
        class_1.prototype.componentDidUpdate = function (prevProps) {
            if (prevProps.assetId !== this.props.assetId) {
                this.loadAssetEvents();
            }
        };
        class_1.prototype.loadAssetEvents = function () {
            return __awaiter(this, void 0, void 0, function () {
                var _a, assetId, queryParams, events, error_1;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, , 3]);
                            _a = this.props, assetId = _a.assetId, queryParams = _a.queryParams;
                            return [4 /*yield*/, connectPromiseToUnmountState(this, this.client.events
                                    .list(__assign(__assign({ limit: SDK_LIST_LIMIT }, queryParams), { filter: __assign(__assign({}, (queryParams && queryParams.filter)), { assetIds: [assetId] }) }))
                                    .autoPagingToArray({ limit: SDK_LIST_LIMIT }))];
                        case 1:
                            events = _b.sent();
                            if (!events || !Array.isArray(events)) {
                                console.error(ERROR_API_UNEXPECTED_RESULTS);
                                return [2 /*return*/];
                            }
                            this.setState({
                                isLoading: false,
                                assetEvents: events,
                            });
                            if (this.props.onAssetEventsLoaded) {
                                this.props.onAssetEventsLoaded(events);
                            }
                            return [3 /*break*/, 3];
                        case 2:
                            error_1 = _b.sent();
                            if (error_1 instanceof CanceledPromiseException !== true) {
                                throw error_1;
                            }
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        class_1.prototype.render = function () {
            var _a = this.props, assetId = _a.assetId, customSpinner = _a.customSpinner, onAssetEventsLoaded = _a.onAssetEventsLoaded, restProps = __rest(_a, ["assetId", "customSpinner", "onAssetEventsLoaded"]);
            var _b = this.state, isLoading = _b.isLoading, assetEvents = _b.assetEvents;
            if (isLoading) {
                return customSpinner || React.createElement(LoadingBlock, null);
            }
            if (assetEvents) {
                return (React.createElement(WrapperComponent, __assign({}, restProps, { assetEvents: assetEvents })));
            }
            return null;
        };
        return class_1;
    }(React.Component)),
    _a.contextType = ClientSDKProxyContext,
    _a; };

var withAssetFiles = function (WrapperComponent) { var _a; return _a = /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1(props) {
            var _this = _super.call(this, props) || this;
            _this.isComponentUnmounted = false;
            _this.state = {
                isLoading: true,
                assetFiles: null,
                assetId: props.assetId,
            };
            return _this;
        }
        class_1.getDerivedStateFromProps = function (props, state) {
            if (props.assetId !== state.assetId) {
                return {
                    isLoading: true,
                    assetFiles: null,
                    assetId: props.assetId,
                };
            }
            return null;
        };
        class_1.prototype.componentDidMount = function () {
            this.client = this.context(WrapperComponent.displayName || '');
            if (!this.client) {
                console.error(ERROR_NO_SDK_CLIENT);
                return;
            }
            this.loadAssetFiles();
        };
        class_1.prototype.componentWillUnmount = function () {
            this.isComponentUnmounted = true;
        };
        class_1.prototype.componentDidUpdate = function (prevProps) {
            if (prevProps.assetId !== this.props.assetId) {
                this.loadAssetFiles();
            }
        };
        class_1.prototype.loadAssetFiles = function () {
            return __awaiter(this, void 0, void 0, function () {
                var _a, assetId, queryParams, files, error_1;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, , 3]);
                            _a = this.props, assetId = _a.assetId, queryParams = _a.queryParams;
                            return [4 /*yield*/, connectPromiseToUnmountState(this, this.client.files
                                    .list(__assign(__assign({ limit: SDK_LIST_LIMIT }, queryParams), { filter: __assign(__assign({}, (queryParams && queryParams.filter)), { assetIds: [assetId] }) }))
                                    .autoPagingToArray())];
                        case 1:
                            files = _b.sent();
                            if (!files || !Array.isArray(files)) {
                                console.error(ERROR_API_UNEXPECTED_RESULTS);
                                return [2 /*return*/];
                            }
                            this.setState({
                                isLoading: false,
                                assetFiles: files,
                            });
                            if (this.props.onAssetFilesLoaded) {
                                this.props.onAssetFilesLoaded(files);
                            }
                            return [3 /*break*/, 3];
                        case 2:
                            error_1 = _b.sent();
                            if (error_1 instanceof CanceledPromiseException !== true) {
                                throw error_1;
                            }
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        class_1.prototype.render = function () {
            var _a = this.props, assetId = _a.assetId, customSpinner = _a.customSpinner, onAssetFilesLoaded = _a.onAssetFilesLoaded, restProps = __rest(_a, ["assetId", "customSpinner", "onAssetFilesLoaded"]);
            var _b = this.state, isLoading = _b.isLoading, assetFiles = _b.assetFiles;
            if (isLoading) {
                return customSpinner || React.createElement(LoadingBlock, null);
            }
            if (assetFiles) {
                return (React.createElement(WrapperComponent, __assign({}, restProps, { assetFiles: assetFiles })));
            }
            return null;
        };
        return class_1;
    }(React.Component)),
    _a.contextType = ClientSDKProxyContext,
    _a; };

var withAssetTimeseries = function (WrapperComponent) { var _a; return _a = /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1(props) {
            var _this = _super.call(this, props) || this;
            _this.isComponentUnmounted = false;
            _this.state = {
                isLoading: true,
                assetTimeseries: null,
                assetId: props.assetId,
            };
            return _this;
        }
        class_1.getDerivedStateFromProps = function (props, state) {
            if (props.assetId !== state.assetId) {
                return {
                    isLoading: true,
                    assetTimeseries: null,
                    assetId: props.assetId,
                };
            }
            return null;
        };
        class_1.prototype.componentDidMount = function () {
            this.client = this.context(WrapperComponent.displayName || '');
            if (!this.client) {
                console.error(ERROR_NO_SDK_CLIENT);
                return;
            }
            this.loadAssetTimeseries();
        };
        class_1.prototype.componentWillUnmount = function () {
            this.isComponentUnmounted = true;
        };
        class_1.prototype.componentDidUpdate = function (prevProps) {
            if (prevProps.assetId !== this.props.assetId) {
                this.loadAssetTimeseries();
            }
        };
        class_1.prototype.loadAssetTimeseries = function () {
            return __awaiter(this, void 0, void 0, function () {
                var _a, assetId, queryParams, assetTimeseries, error_1;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!this.client.timeseries) {
                                console.error(ERROR_API_UNEXPECTED_RESULTS);
                                return [2 /*return*/];
                            }
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 3, , 4]);
                            _a = this.props, assetId = _a.assetId, queryParams = _a.queryParams;
                            return [4 /*yield*/, connectPromiseToUnmountState(this, this.client.timeseries
                                    .list(__assign(__assign({ limit: SDK_LIST_LIMIT }, queryParams), { filter: __assign(__assign({}, (queryParams && queryParams.filter)), { assetIds: [assetId] }) }))
                                    .autoPagingToArray())];
                        case 2:
                            assetTimeseries = (_b.sent());
                            this.setState({
                                isLoading: false,
                                assetTimeseries: assetTimeseries,
                            });
                            if (this.props.onAssetTimeseriesLoaded) {
                                this.props.onAssetTimeseriesLoaded(assetTimeseries);
                            }
                            return [3 /*break*/, 4];
                        case 3:
                            error_1 = _b.sent();
                            if (error_1 instanceof CanceledPromiseException !== true) {
                                throw error_1;
                            }
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
        class_1.prototype.render = function () {
            var _a = this.props, assetId = _a.assetId, customSpinner = _a.customSpinner, onAssetTimeseriesLoaded = _a.onAssetTimeseriesLoaded, restProps = __rest(_a, ["assetId", "customSpinner", "onAssetTimeseriesLoaded"]);
            var _b = this.state, isLoading = _b.isLoading, assetTimeseries = _b.assetTimeseries;
            if (isLoading) {
                return customSpinner || React.createElement(LoadingBlock, null);
            }
            if (assetTimeseries) {
                return (React.createElement(WrapperComponent, __assign({}, restProps, { assetTimeseries: assetTimeseries })));
            }
            return null;
        };
        return class_1;
    }(React.Component)),
    _a.contextType = ClientSDKProxyContext,
    _a; };

// Copyright 2020 Cognite AS
var defaultTheme = {
    // ant design colors
    primaryColor: '#1890ff',
    infoColor: '#1890ff',
    successColor: '#1890ff',
    processingColor: '#1890ff',
    errorColor: '#f5222d',
    highlightColor: '#f5222d',
    selectColor: '#e6f7ff',
    warningColor: '#faad14',
    normalColor: '#d9d9d9',
    white: '#fff',
    black: '#000',
    textColor: 'rgba(0,0,0, 0.65)',
    textColorSecondary: 'rgba(0,0,0, 0.45)',
    textColorInverse: '#fff',
    textColorAccent: '#40a9ff',
    // gearbox colors and styles
    lightGrey: '#f5f5f5',
    lightShadow: 'rgba(0, 0, 0, 0.05) 1px 6px 20px 8px, rgba(0, 0, 0, 0.11) 0px 6px 6px',
    containerColor: '#fff',
    containerBorderColor: '#EEE',
    textColorDisabled: 'rgba(0,0,0, 0.25)',
    buttonBorderColor: '#d9d9d9',
    buttonDisabledColor: '#f5f5f5',
};

var ThemeWrapper = function (_a) {
    var theme = _a.theme, children = _a.children;
    var external = theme && theme.gearbox ? theme.gearbox : {};
    var resultTheme = {
        gearbox: __assign(__assign({}, defaultTheme), external),
    };
    return React.createElement(ThemeProvider, { theme: resultTheme }, children);
};
ThemeWrapper.defaultProps = { theme: { gearbox: __assign({}, defaultTheme) } };
var WithThemeComponent = withTheme(ThemeWrapper);
var withDefaultTheme = function (Component) {
    var _a;
    return _a = /** @class */ (function (_super) {
            __extends(ThemeWrappedComponent, _super);
            function ThemeWrappedComponent() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            ThemeWrappedComponent.prototype.render = function () {
                return (React.createElement(WithThemeComponent, null,
                    React.createElement(Component, __assign({}, this.props, { key: "" }))));
            };
            return ThemeWrappedComponent;
        }(React.Component)),
        _a.displayName = "" + (Component.displayName || Component.name),
        _a;
};

var withTimeseries = function (WrapperComponent) { var _a; return _a = /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1(props) {
            var _this = _super.call(this, props) || this;
            _this.isComponentUnmounted = false;
            _this.state = {
                isLoading: true,
                timeseries: null,
                timeseriesId: props.timeseriesId,
            };
            return _this;
        }
        class_1.getDerivedStateFromProps = function (props, state) {
            if (props.timeseriesId !== state.timeseriesId) {
                return {
                    isLoading: true,
                    timeseries: null,
                    timeseriesId: props.timeseriesId,
                };
            }
            return null;
        };
        class_1.prototype.componentDidMount = function () {
            this.client = this.context(WrapperComponent.displayName || '');
            if (!this.client) {
                console.error(ERROR_NO_SDK_CLIENT);
                return;
            }
            this.loadTimeseries();
        };
        class_1.prototype.componentWillUnmount = function () {
            this.isComponentUnmounted = true;
        };
        class_1.prototype.componentDidUpdate = function (prevProps) {
            if (prevProps.timeseriesId !== this.props.timeseriesId) {
                this.loadTimeseries();
            }
        };
        class_1.prototype.loadTimeseries = function () {
            return __awaiter(this, void 0, void 0, function () {
                var timeseries, error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, connectPromiseToUnmountState(this, this.client.timeseries.retrieve([{ id: this.props.timeseriesId }]))];
                        case 1:
                            timeseries = _a.sent();
                            this.setState({
                                isLoading: false,
                                timeseries: timeseries[0],
                            });
                            return [3 /*break*/, 3];
                        case 2:
                            error_1 = _a.sent();
                            if (error_1 instanceof CanceledPromiseException !== true) {
                                throw error_1;
                            }
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        class_1.prototype.render = function () {
            var _a = this.props, timeseriesId = _a.timeseriesId, customSpinner = _a.customSpinner, restProps = __rest(_a, ["timeseriesId", "customSpinner"]);
            var _b = this.state, isLoading = _b.isLoading, timeseries = _b.timeseries;
            if (isLoading) {
                return customSpinner || React.createElement(LoadingBlock, null);
            }
            if (timeseries) {
                return (React.createElement(WrapperComponent, __assign({}, restProps, { timeseries: timeseries })));
            }
            return null;
        };
        return class_1;
    }(React.Component)),
    _a.contextType = ClientSDKProxyContext,
    _a; };

export { withAsset as a, withAssetFiles as b, withAssetEvents as c, defaultTheme as d, withAssetTimeseries as e, withTimeseries as f, withDefaultTheme as w };
